import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import type { ProjectContext, ReportCategory, ReportGenerationParams } from '../../shared/types';
import ReportPreview from '../shared/components/Preview';
import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption } from '../shared/types';
import { getPreviewURL } from './utils';

type Props = {
  params: ReportGenerationParams;
  format: FormatName | null;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
};

const Preview: VoidFunctionComponent<Props> = ({
  params: { report_type: reportType },
  format,
  includeOptions,
  dependencyMetadataOptions,
}: Props) => {
  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext) as ProjectContext;
  const url = getPreviewURL({
    projectRevisionLocator: reportContext.revision,
    reportType,
    format,
    includeOptions,
    dependencyMetadataOptions,
  });

  return (
    <ReportPreview
      previewURL={url}
      reportType={reportType as ReportCategory}
      format={format}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
    />
  );
};

export default Preview;
